import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;

  input {
    width: 100%;
  }

  button {
    background: var(--green);
    align-self: flex-start;

    &:hover {
      background: #32bd2f !important;
    }
  }
`;

export const Disclaimer = styled.p`
  font-size: 1rem;
  padding: 1rem;
  border: 1px dashed white;
`;

export const Preview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 20rem;
  overflow-y: scroll;
`;
